// dashboard strings (es).
// Machine-drafted — review with a native speaker before launch.
const dashboard = {
	dashboard: {
		title: 'Panel',
		cards: 'Tarjetas',
		searchCardPlaceholder: 'Introduce el título de la tarjeta',
		viewMore: 'Ver más',
		createNewCard: 'Crear tarjeta nueva',
		createNewCardDesc: 'CardClan te anima a conectar con tus seres queridos y compartir amor con ellos.',
		letsCreate: 'Vamos a crear',
		selectTemplate: 'Seleccionar plantilla',
		searchCategoryPlaceholder: 'Introduce el nombre de la categoría',
		seeLess: 'Ver menos',
		moreCount: '+%{count} más',
		notEnoughData: 'No hay datos suficientes para mostrar.',
		emailsOpenRate: 'Tasa de apertura de correos',
		cardsOpenRate: 'Tasa de apertura de tarjetas',
		tour: {
			dashboardTitle: 'Panel',
			dashboardDesc: '¡Bienvenido a tu panel! Aquí puedes ver un resumen de tus actividades.',
			createCardTitle: 'Crear tarjeta',
			createCardDesc: 'Haz clic aquí para crear una tarjeta nueva a partir de una plantilla.',
			searchCardsTitle: 'Buscar tarjetas',
			searchCardsDesc: 'Aquí puedes buscar tus tarjetas existentes.',
		},
		stats: {
			cardsStatistics: 'Estadísticas de tarjetas',
			graph: 'Gráfico',
			contactsEngagement: 'Interacción de contactos',
			contactEngagement: 'Interacción de contacto',
			emailsOpened: 'Correos abiertos',
			cardsOpened: 'Tarjetas abiertas',
			conversionRate: 'Tasa de conversión',
			totalReactions: 'Reacciones totales',
			totalComments: 'Comentarios totales',
			totalDownloads: 'Descargas totales',
			last7Days: 'Últimos 7 días',
			last15Days: 'Últimos 15 días',
			last30Days: 'Últimos 30 días',
			last2Months: 'Últimos 2 meses',
			last6Months: 'Últimos 6 meses',
			lastYear: 'Último año',
			allCards: 'Todas las tarjetas',
		},
		swal: {
			cardAlreadyDeliveredTitle: 'La tarjeta ya fue entregada',
			cardAlreadyDeliveredText: 'Puedes clonar esta tarjeta para programar una nueva',
			workflowCardTitle: 'Esta tarjeta se usa en un flujo de trabajo',
			workflowCardText: 'Editar las etiquetas de combinación o el contenido puede romper tus flujos de trabajo existentes. ¿Seguro que quieres continuar?',
			cancel: 'Cancelar',
			editAnyway: 'Editar de todos modos',
			openCardError: 'Ocurrió un problema al abrir esta tarjeta. Contacta con soporte',
			cardClonedTitle: 'Tarjeta clonada correctamente',
			cardClonedText: 'La tarjeta se ha clonado en el espacio de trabajo seleccionado.',
			deleteConfirmTitle: '¿Estás seguro?',
			deleteConfirmText: '¿Quieres eliminar esta tarjeta?',
			no: 'No',
			yes: 'Sí',
			error: 'Error',
			warning: 'Advertencia',
			noCategoriesFound: '¡No se encontraron categorías de diseño!',
			oopsExclaim: '¡Vaya!',
			oops: 'Vaya',
			noWorkspaces: 'Parece que aún no tienes ningún espacio de trabajo.',
		},
	},
};
export default dashboard;
